import { Company } from "./company.model"

export class Firmware {
    public Id?: number
    public Model?: string
    public Version?: string
    public FileName?: string
    public desciription?: string
    public PacketSize?: number
    public EndSize?: number
    public UDate?: Date
    public companyId?: number
    public status?:boolean
    public company?:Company
}